import(/* webpackMode: "eager" */ "/vercel/path0/app/support/page.tsx")